import React from 'react'


function Loader() {
  return (
    <div className="flex items-center justify-center h-screen bg-white">
    <img
      src="/assets/new logo.png"
      alt="Loading..."
      className="loaderlogo animate-pulse"
    />
  </div>
  )
}

export default Loader